export default __webpack_public_path__ + "static/media/26075_14.f38e95e8.svg";